import { render, staticRenderFns } from "./amendRecord.vue?vue&type=template&id=139022dc&scoped=true&"
import script from "./amendRecord.vue?vue&type=script&lang=js&"
export * from "./amendRecord.vue?vue&type=script&lang=js&"
import style0 from "./amendRecord.vue?vue&type=style&index=0&id=139022dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139022dc",
  null
  
)

export default component.exports